import './ReportPageHeader.scss';

import { ReactNode } from 'react';
import { ReactComponent as Trackman } from 'svg/Trackman.svg';
import { useAutoAnimate } from '@formkit/auto-animate/react';

type Props = {
  children: ReactNode;
};

const ReportPageHeader = ({ children }: Props) => {
  const [parent] = useAutoAnimate();

  return (
    <div className='ReportPageHeader-container'>
      <div className='ReportPageHeader-metadata' ref={parent}>
        {children}
      </div>
      <Trackman />
    </div>
  );
};

export default ReportPageHeader;
